/**
 * The separator styles a number field can be formatted with.
 *
 * These values are a wire contract in three directions, so do not rename them:
 * - the Word add-in interpolates the value straight into the merge expression
 *   (`#numbers.formatDecimal(value, 0, 'COMMA', 2, 'POINT')`), where they must match Thymeleaf's
 *   `NumberPointType`
 * - the Manager saves them as part of the corp config
 * - the backend stores them as plain Strings and never interprets them
 *
 * `DEFAULT` means "use the locale default". Thymeleaf understands it, but neither the add-in's
 * format panels nor the Manager's corp defaults offer it, because the result would depend on the
 * server locale at merge time.
 */
export enum NumberFormatSeparator {
  POINT = 'POINT',
  COMMA = 'COMMA',
  WHITESPACE = 'WHITESPACE',
  NONE = 'NONE',
  DEFAULT = 'DEFAULT',
}
